// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { CostDataUpload } from '@/costs/components/cost-data-upload';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSuccess?: () => void;
}

export function CostDataImportDialog(props: Props) {
  return (
    <Dialog fullWidth maxWidth="lg" open={props.isOpen} onClose={props.onClose}>
      <DialogTitle>Upload cost data</DialogTitle>
      <DialogContent dividers>
        <CostDataUpload onClose={props.onClose} onSuccess={props.onSuccess} />
      </DialogContent>
    </Dialog>
  );
}
